
import React, { useRef, useEffect } from 'react';
import { createStore, Provider } from 'jotai';
import { noop } from 'lodash';
import { generateAllCategory } from '../utils';
import * as atoms from './atom';

export const ManagementProvider = (props: atoms.ManagementStoreAtom & {
  children: React.ReactNode;
}) => {
  const {
    user,
    visible,
    dataSource,
    filterMeta,
    savedFilters,
    drilldownLimit,
    disabledDataSources = [],
    disabledOperators = [],
    disableCreateFilter = false,
    isFilterMetaLoading = false,
    isFilterMetaError = false,
    isSavedFiltersLoading = false,
    isSavedFiltersError = false,
    onCloneFilter = noop,
    onEditFilter = noop,
    onEnableFilter = noop,
    onCreateFilter = noop,
    onDeleteFilter = noop,
    onDataSourceChange = noop,
    onClose = noop,
    onFilterMetaRetry = noop,
    onSavedFiltersRetry = noop,
  } = props;

  const store = useRef(createStore());

  useEffect(() => {
    store.current.set(atoms.dataSource, dataSource);
  }, [dataSource]);

  useEffect(() => {
    store.current.set(atoms.savedFilters, savedFilters || []);
  }, [savedFilters]);

  useEffect(() => {
    if (filterMeta) {
      store.current.set(atoms.filterMeta, filterMeta);
      store.current.set(atoms.currentCategory, generateAllCategory());
    }
  }, [filterMeta]);

  useEffect(() => {
    store.current.set(atoms.visible, visible);
  }, [visible]);

  useEffect(() => {
    store.current.set(atoms.user, user);
  }, [user]);

  useEffect(() => {
    store.current.set(atoms.drilldownLimit, drilldownLimit);
  }, [drilldownLimit]);

  useEffect(() => {
    store.current.set(atoms.disabledDataSources, disabledDataSources);
  }, [disabledDataSources]);

  useEffect(() => {
    store.current.set(atoms.disableCreateFilter, disableCreateFilter);
  }, [disableCreateFilter]);

  useEffect(() => {
    store.current.set(atoms.disabledOperators, disabledOperators);
  }, [disabledOperators]);

  useEffect(() => {
    store.current.set(atoms.isFilterMetaLoading, isFilterMetaLoading);
  }, [isFilterMetaLoading]);

  useEffect(() => {
    store.current.set(atoms.isFilterMetaError, isFilterMetaError);
  }, [isFilterMetaError]);

  useEffect(() => {
    store.current.set(atoms.isSavedFiltersLoading, isSavedFiltersLoading);
  }, [isSavedFiltersLoading]);

  useEffect(() => {
    store.current.set(atoms.isSavedFiltersError, isSavedFiltersError);
  }, [isSavedFiltersError]);

  // callbacks
  useEffect(() => {
    store.current.set(atoms.callbacks, {
      onCloneFilter,
      onEditFilter,
      onCreateFilter,
      onDeleteFilter,
      onDataSourceChange,
      onClose,
      onEnableFilter,
      onFilterMetaRetry,
      onSavedFiltersRetry,
    });
  }, [
    onCloneFilter,
    onEnableFilter,
    onEditFilter,
    onCreateFilter,
    onDeleteFilter,
    onDataSourceChange,
    onClose,
    onFilterMetaRetry,
    onSavedFiltersRetry
  ]);

  return (
    <Provider store={store.current}>
      {props.children}
    </Provider>
  );
};
